import { useCallback } from 'react';
import { TransitionLifeCycleType } from '@/player-config/src/types/RemotionPlayerConfigTypes/Animations/Transitions/Transitions.types';
import { classnames } from '@/libs/utils';

export const TransitionLifeCycleTab = ({
  isActive,
  transitionLifeCycle,
  label,
  isTransitionApplied,
  onClick
}: {
  isActive: boolean;
  label: string;
  isTransitionApplied: boolean;
  transitionLifeCycle: TransitionLifeCycleType;
  onClick: (lifeCycle: TransitionLifeCycleType) => void;
}) => {
  const transitionLifeCycleTabClick = useCallback(() => {
    onClick(transitionLifeCycle);
  }, [onClick, transitionLifeCycle]);

  return (
    <div
      data-testid={`transition-lifecycle-tab-${transitionLifeCycle.toLowerCase()}`}
      onClick={transitionLifeCycleTabClick}
      className={classnames(
        'flex flex-1 cursor-pointer select-none items-center justify-center rounded-lg p-2 text-center text-xs hover:bg-white',
        isActive ? 'bg-white shadow-sm' : ''
      )}
    >
      <div className="flex-1">{label}</div>
      <div
        data-testid={`transition-indicator-${transitionLifeCycle.toLowerCase()}`}
        className={classnames('size-2 rounded-full', isTransitionApplied ? 'bg-red-500' : 'bg-slate-300')}
      />
    </div>
  );
};
